import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './Referral.css';

// 配置axios baseURL
axios.defaults.baseURL = (typeof window !== 'undefined' ? window.location.protocol + '//' + window.location.host : '') + '/api';

const Referral = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [referralData, setReferralData] = useState(null);

  useEffect(() => {
    fetchReferralData();
  }, []);

  const fetchReferralData = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      
      if (!token) {
        navigate('/login');
        return;
      }

      const response = await axios.get('/referral/all', {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.data.success) {
        setReferralData(response.data.data);
      }
    } catch (error) {
      console.error('获取推荐数据失败:', error);
      if (error.response?.status === 401) {
        navigate('/login');
      }
    } finally {
      setLoading(false);
    }
  };

  const getStatusText = (status) => {
    const statusMap = {
      'registered': '已注册',
      'premium': '高级会员',
      'vip': 'VIP会员'
    };
    return statusMap[status] || status;
  };

  const getStatusColor = (status) => {
    const colorMap = {
      'registered': '#52c41a',
      'premium': '#1890ff',
      'vip': '#faad14'
    };
    return colorMap[status] || '#999';
  };

  if (loading) {
    return (
      <div className="referral-container">
        <div className="referral-loading">加载中...</div>
      </div>
    );
  }

  if (!referralData) {
    return (
      <div className="referral-container">
        <div className="referral-error">加载失败，请刷新重试</div>
      </div>
    );
  }

  const { stats, points } = referralData;

  return (
    <div className="referral-container">
      {/* 头部 */}
      <div className="referral-header">
        <button className="back-button" onClick={() => navigate('/profile')}>
          <span className="back-icon">←</span>
        </button>
        <h1 className="referral-title">一键分享</h1>
      </div>

      {/* 统计卡片 */}
      <div className="stats-cards">
        <div className="stat-card">
          <div className="stat-value">{stats.totalReferrals}</div>
          <div className="stat-label">总推荐人数</div>
        </div>
        <div className="stat-card">
          <div className="stat-value">{stats.todayReferrals}</div>
          <div className="stat-label">今日推荐</div>
        </div>
        <div className="stat-card">
          <div className="stat-value">{points.remainingPoints}</div>
          <div className="stat-label">剩余积分</div>
        </div>
        <div className="stat-card">
          <div className="stat-value">{stats.vipReferrals}</div>
          <div className="stat-label">VIP推荐</div>
        </div>
      </div>

      {/* 积分规则 */}
      <div className="rules-section">
        <h2 className="section-title">积分规则</h2>
        <ul className="rules-list">
          <li>好友通过您的推荐码注册，您将获得 <strong>1积分</strong></li>
          <li>好友升级为高级会员，您将额外获得 <strong>1积分</strong></li>
          <li>好友升级为VIP会员，您将额外获得 <strong>2积分</strong></li>
          <li>积分可用于兑换会员权益或其他福利</li>
        </ul>
      </div>

      {/* 推荐列表 */}
      <div className="referral-list-section">
        <h2 className="section-title">
          推荐记录
          <span className="list-count">({stats.referralList.length})</span>
        </h2>
        
        {stats.referralList.length === 0 ? (
          <div className="empty-list">
            <div className="empty-icon">📋</div>
            <div className="empty-text">暂无推荐记录</div>
            <div className="empty-hint">分享您的推荐链接，邀请好友注册吧！</div>
          </div>
        ) : (
          <div className="referral-list">
            {stats.referralList.map((item, index) => (
              <div key={index} className="referral-item">
                <div className="referral-item-header">
                  <div className="referral-user">
                    <div className="user-avatar">
                      {item.nickname.charAt(0)}
                    </div>
                    <div className="user-info">
                      <div className="user-nickname">{item.nickname}</div>
                      <div className="user-phone">{item.phone}</div>
                    </div>
                  </div>
                  <div 
                    className="referral-status"
                    style={{ color: getStatusColor(item.status) }}
                  >
                    {getStatusText(item.status)}
                  </div>
                </div>
                <div className="referral-item-footer">
                  <div className="referral-date">注册时间: {item.joinDate}</div>
                  <div className="referral-points">+{item.pointsAwarded}积分</div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* 积分记录 */}
      {points.recentLogs.length > 0 && (
        <div className="points-log-section">
          <h2 className="section-title">积分记录</h2>
          <div className="points-log-list">
            {points.recentLogs.map((log, index) => (
              <div key={index} className="points-log-item">
                <div className="log-description">
                  {log.description}
                  {log.relatedUser && <span className="related-user">({log.relatedUser})</span>}
                </div>
                <div className="log-right">
                  <div className={`log-points ${log.points > 0 ? 'positive' : 'negative'}`}>
                    {log.points > 0 ? '+' : ''}{log.points}
                  </div>
                  <div className="log-time">{log.createdAt}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default Referral;

